import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../utils/format";
import { useHistory } from "react-router-dom";
import Rows from "../../components/Rows";
import CloseIcon from "../../icons/x.svg";
import eyeIcon from "../../icons/eye.svg";

const DeliveryNotePayments = ({ blPayments, onClose }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const columns = [
        {
            label: t("columns.attachedAt") || "Attachée le",
            key: "createdAt",
            render: (_, row) => formatDateTime(row.createdAt),
        },
        {
            label: t("columns.paymentNumber") || "N°",
            key: "reference",
        },
        {
            label: t("columns.paymentType") || "Nature",
            key: "nature",
            render: (_, row) => row.type?.name,
        },
        {
            label: t("paymentDetails.amount") || "Montant total",
            key: "amount",
        },
        {
            label: t("paymentDetails.montant_attached") || "Montant attaché",
            key: "attachedAmount",
        },
        {
            key: "actions",
            render: (_, row) => (
                <button
                    className="flex items-center justify-center w-10 h-10 rounded-[12px] bg-gray-100 border border-gray-300 hover:bg-gray-200 text-[#043F88]"
                    onClick={() => history.push(`/payments/details/${row.paymentId}`)}
                >
                    <img src={eyeIcon} alt="details" className="w-6 h-6" />
                </button>
            ),
        }
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1050]">
            <div className="relative bg-[#F9FAFC] h-auto rounded-[12px] p-8 shadow-lg flex flex-col max-w-[90%]  min-w-[400px]w-[70%]  ">
                {/* Close Button */}
                <button
                    className="absolute top-4 right-4 w-8 h-8 bg-[#F2F3F3] flex items-center justify-center rounded-full shadow-md"
                    onClick={onClose}
                >
                    <img src={CloseIcon} alt="Close" />
                </button>

                {/* Title */}
                <div className="mb-4">
                    <h1 className="text-[24px] font-semibold text-black">
                        {t("titles.payments") || "Pièces de règlement"}
                    </h1>
                </div>

                {/* Payments List */}
                <div className="flex-1 overflow-y-auto mb-4">
                    {blPayments?.length > 0 ? (
                        <Rows columns={columns} data={blPayments} expandable={false} />
                    ) : (
                        <div className="text-center text-gray-400 py-10">
                        </div>
                    )   }
                </div>
            </div>
        </div>
    );
};

export default DeliveryNotePayments;
